import React,{useState} from "react"
import EditButton from "./EditButton";
import {Modal,ModalHeader,ModalBody,ModalFooter} from "reactstrap" 
import AppContext from "./AppContext";
import { useGlobal } from "./Reducer";
import Api from "./Api";
import ImageEditor,{BACKGROUND} from "./ImageEditor";
  export default (props)=>
    {
 
        const [globalState,globalActions]=useGlobal();
        const [editMode,setEditMode]=useState(false);
        const [showBgChooser,setShowBgChooser]=useState(false);


        const changeBgImage=(image)=>{
            globalActions.loading(true);
            globalState.appData.background_image=image;
            Api.changeBackgroundImage(image,globalState.appData.id).catch(err=>{
           
            }).finally(()=>{
                globalActions.loading(false);
            });
        }

        return (<div className="top_display">
            {editMode==true && <MessageEditor onClose={()=>{
                setEditMode(false);
            }} />}

            {showBgChooser && <ImageEditor onClose={()=>setShowBgChooser(false)}
                    withImage={(image)=>changeBgImage(image)}
            type={BACKGROUND}/>}

        <div className="container">
            <div className="row">
           
           { globalState.adminMode==true &&    <div className="whitebg   top_display_box d-none d-lg-block">
                    <div 
                    style={{
                        float:"left",
                        marginLeft:-10,
                        marginTop:5,
                        marginBottom:5                      
                    }}
                    
                   className="centered changeable msgset" ref_tag="header_setter">
                        <div className="globaleditbtn  hvr-shrink" data-toggle="tooltip" data-placement="right" title="Edit Title and Message">
                           <EditButton onClick={()=>{
                              
                               setEditMode(true);
                           }} />
                        </div>
                    </div>
                
    
                  <div className="blacktext lvl1"  >{globalState.appData.headers.title} one</div>
                   <div className="blacktext lvl2">{globalState.appData.headers.sub}</div>
                   
                </div>}
            </div>
        </div>
        <div className="ramro">
        {false  &&<div style={{textAlign:"center",padding:10}}>
            <a className="redALink" href='https://www.here4tn.com/' target="_blank" style={{fontSize:20,
              fontFamily: "MeNfont",
            fontWeight:"bolder"}}>
        Coronavirus (COVID-19) resources are available at <u>Here4TN.com</u>  to help you learn ways to be mindful, manage stress and get the latest updates.
        </a>
        </div>}
        <img src={globalState.appData.background_image} className="img-fluid full-width main_image ramro" alt="Background Image" style={{backgroundColor:"rgb(208, 210, 208)"}}/>
        </div>
      
        <div className="whitebg   top_display_box_mob d-lg-none d-sm-block ">


            <div
            
            style={{
                float:"left",
                marginLeft:-10,
                marginTop:5,
                marginBottom:5
            }}
            
             className="centered changeable msgset" ref_tag="header_setter">
                <div className="globaleditbtn  hvr-shrink" data-toggle="tooltip" data-placement="right" title="Edit Title and Message">
                <EditButton/>
                </div>
            </div>
            <div className="blacktext lvl1"> {globalState.appData.headers.title}</div>
    
    
            <div className="blacktext lvl2" ng-if="!client_introtitle_input_field">{globalState.appData.headers.sub}</div>
    
    
    
    
        </div>
    
    
        <div className="changeable" ref_tag="background" id="background-setter" style={{display:"block"}}>
            <div
            
            style={{marginTop:-90,
                right:10,
                float:"right",
                marginRight:15,
                position:"absolute"
            }}
            className="centered">
                <div className="globaleditbtn  hvr-shrink" data-toggle="tooltip" data-placement="top" title="" 
                data-original-title="Change Background" 
               >
            
                    <EditButton onClick={()=>setShowBgChooser(true)} />
                </div>
            </div>
    
            
        </div>
        </div>
    );
    }





 const MessageEditor = (props)=>{



    const [globalState,globalActions]=useGlobal();
    const [title,setTitle]=useState(globalState.appData.headers.title)
    const [sub,setSub]=useState(globalState.appData.headers.sub)

    const save=()=>{
        globalState.appData.headers.title=title;
        globalState.appData.headers.sub=sub;
        Api.saveHeaders(title,sub,globalState.appData.id);
        props.onClose();
    };

    
   
    return (<Modal  centered={true} size="lg" isOpen={true}>
            <ModalHeader>Message Editor</ModalHeader>
            <ModalBody>
                    <div>
                        <div className="form-group"> 
                            <label>Title</label>
                            <input value={title} onChange={e=>setTitle(e.target.value)} className="form-control" type="text" />
                        </div>

                        <div className="form-group"> 
                            <label>Sub Title</label>
                            <input value={sub} onChange={e=>setSub(e.target.value)}  className="form-control" type="text" />
                        </div>



                    </div>

            </ModalBody>
            <ModalFooter>
            <button onClick={save} className="btn btn-success">Save</button>
            <button onClick={props.onClose} className="btn btn-primary">Cancel</button>
                
            </ModalFooter>

    </Modal>);

 }